(function() {
	"use strict"

	angular.module( "ATMGurus" )

	/*-------------------------------------------------------------
	*
	*	Error Service
	*
	*	Module based error service
	*
	----------------------------------------------------------------*/
	.service( "ErrorService", [
		"$rootScope",
		function( $rootScope ) {

			var modules = {
				applicationWide: undefined,				// opens inside a modal window
				authError: undefined,
				generic: undefined,
				addressBook: undefined,
				shipping: undefined,
				charging: undefined,
				chargingDetails: undefined,
				userActions: undefined,
				paymentDate: undefined,
				pwdreset: undefined, 					// errors when password resetting
				confirmation: undefined, 			// confirmation page  warning needs to be displayed if some order from tha cart fails
				checkout: undefined						// non module-specific checkout errors
			};

			// holds errors collection
			var errors ={};

			// in case of error/warning modals we can set the title here
			var statusModalTitle = undefined;

			/**
			*	clear all errors on login ( it makes more sense having it here)
			*
			*/
			$rootScope.$on( "auth.login", function() {
				errors = {};
			})


			return {

				get: function( module ) {
					if ( errors.hasOwnProperty( module ) ) {
						return errors[ module ]
					}
				},

				/**
				*
				*	message -> title
				*	type -> error/warning
				*	additionalInfo -> either array or singke message
				*/
				setGeneralError: function( message, type, additionalInfo ) {

					var allowedTypes = [ "error", "warning" ];

					if (_.isEmpty( errors[ "applicationWide" ] ) ) {
						errors[ "applicationWide" ] = {
							error: {
								title: undefined,
								additionalInfo: undefined
							},
							warning: {
								title: undefined,
								additionalInfo: undefined
							}
						}
					}

					switch ( type ) {
						case "warning":
							statusModalTitle = "Warning!"
							break;
						case "error":
							statusModalTitle = "Error!";
							break;
					}

					errors[ "applicationWide" ][ type ].title = message;

					if ( !_.isUndefined( additionalInfo ) ) {

						if ( _.isUndefined( errors[ "applicationWide" ][ type ].additionalInfo ) ) {
							errors[ "applicationWide" ][ type ].additionalInfo = [];
						}

						if ( _.isObject( additionalInfo ) ) {
							_.forEach( additionalInfo, function( single ) {
								if ( _.isArray( single ) ) {
									errors[ "applicationWide" ][type].additionalInfo.push( single[0] )
								}
								else {
									errors[ "applicationWide" ][type].additionalInfo = additionalInfo;
								}
							} )
						}
					}
				},

				/**
				*
				*	for status modal ( error / warning )
				*	fetch modal title from here
				*
				*/
				getModalTitle: function() {
					return statusModalTitle;
				},

				set: function( message, module ) {

					if ( !message ) {
						return
					}

					if ( _.isUndefined( errors[ module ] ) ) {
						errors[ module ] = [];
					}

					if ( _.isObject( message ) ) {
						_.forEach( message, function( single ) {
							if ( _.isArray( single ) ) {
								// we only accept the first children, no additional level of recursion
								errors[module].push( single[0] );
							}
							else {
								errors[module].push( single );
							}
						})
					}
					else {
						errors[ module ].push( message );
					}
				},

				reset: function( module ) {
					if ( modules.hasOwnProperty( module ) ) {
						errors[ module ] = undefined;
					}
				}
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/services/ErrorService.js